import ImageWithPoints from '../../../Components/imageWithPoints/ImageWithPoints';
import docImg from '../../../assets/images/png/male-doc.png';
import checkIcon from '../../../assets/images/svg/check-white.svg';
import icon from '../../../assets/images/png/end-call-red.png';
import './benefitsOFOnlineConsult.css';

function benefitsOFOnlineConsult() {
  return (
    <div className="benefitsOFOnlineConsult">
      <ImageWithPoints
        iconImage={icon}
        image={docImg}
        title="Benefits of Online Consultation"
        icon={checkIcon}
        iconpoints={[
          {
            heading: 'Consult Top Doctors 24x7',
            desc: 'Connect instantly with a 24x7 specialist or choose to video visit a particular doctor.'
          },
          {
            heading: 'Convenient and Easy',
            desc: 'Start an instant consultation within 2 minutes or do video consultation at the scheduled time.'
          },
          {
            heading: '100% Safe Consultations',
            desc: 'Be assured that your online consultation will be fully private and secured.'
          },
          {
            heading: 'Similar Clinic Experience',
            desc: 'Experience clinic-like consultation through a video call with the doctor.'
          }
        ]}
      />
    </div>
  );
}

export default benefitsOFOnlineConsult;
